import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

// Maps the former `$position` prop to the matching border-cross class.
const POSITION_CLASS = {
  'top-left': styles.statItemTopLeft,
  'top-center': styles.statItemTopCenter,
  'top-right': styles.statItemTopRight,
  'bottom-left': styles.statItemBottomLeft,
  'bottom-right': styles.statItemBottomRight
}

const statItemClass = (position, extra) => {
  const classes = [styles.statItem]
  if (extra) {
    classes.push(extra)
  }
  if (POSITION_CLASS[position]) {
    classes.push(POSITION_CLASS[position])
  }
  return classes.join(' ')
}

function GetFasterStats({
  eyebrow,
  title,
  stats = []
}) {
  // Expected order: [top-left, top-right, center, bottom-left, bottom-right]
  const [topLeft, topRight, center, bottomLeft, bottomRight] = stats

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          {eyebrow && <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>}
          {title && (
            <h2 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h2>
          )}
        </div>

        <div className={styles.statsGrid}>
          {topLeft && (
            <div className={statItemClass('top-left')}>
              <span className={styles.statValue}><Text type="heading-3" color={$textPrimary.dark}>{topLeft.value}</Text></span>
              <span className={styles.statLabel}><Text type="small" color={$textTertiary.dark}>{topLeft.label}</Text></span>
            </div>
          )}

          {center && (
            <div className={statItemClass('top-center', styles.centerStatItem)}>
              <span className={`${styles.statValue} ${styles.centerStatValue}`}><Text type="heading-2" color={$textPrimary.dark}>{center.value}</Text></span>
              <span className={styles.statLabel}><Text type="small" color={$textTertiary.dark}>{center.label}</Text></span>
            </div>
          )}

          {topRight && (
            <div className={statItemClass('top-right')}>
              <span className={styles.statValue}><Text type="heading-3" color={$textPrimary.dark}>{topRight.value}</Text></span>
              <span className={styles.statLabel}><Text type="small" color={$textTertiary.dark}>{topRight.label}</Text></span>
            </div>
          )}

          {bottomLeft && (
            <div className={statItemClass('bottom-left')}>
              <span className={styles.statValue}><Text type="heading-3" color={$textPrimary.dark}>{bottomLeft.value}</Text></span>
              <span className={styles.statLabel}><Text type="small" color={$textTertiary.dark}>{bottomLeft.label}</Text></span>
            </div>
          )}

          {bottomRight && (
            <div className={statItemClass('bottom-right')}>
              <span className={styles.statValue}><Text type="heading-3" color={$textPrimary.dark}>{bottomRight.value}</Text></span>
              <span className={styles.statLabel}><Text type="small" color={$textTertiary.dark}>{bottomRight.label}</Text></span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default GetFasterStats
